/* KC Nadruk EN (US, terminal B 19.10) – angielska nakladka na kreator nadrukow. Ladowana TYLKO na rynku US
 * (sections/kc-nadruk-kreator.liquid), po kc-nadruk-engine.js i PRZED kc-nadruk-ui.js. Na PL nie istnieje -> PL bez zmian.
 * 1) window.KCN_US(P) – wolane przez kc-nadruk-ui.js po zbudowaniu konfiguracji produktow: etykiety, nazwy opcji, notatki
 *    i domyslne teksty US. Wartosci pol powiazanych z kc-options (kco) zostaja bez zmian.
 * 2) teksty w DOM kreatora, 3) podpisy na canvasie ("Zdjecie N"), 4) etykiety wlasciwosci w koszyku (EN, cale). _kca bez zmian. */
(function (global) {
  'use strict';
  var doc = document;

  // ---------- 1) konfiguracja produktow ----------
  var LABEL = {
    'Zdjęcia': 'Photos', 'Odstępy między zdjęciami': 'Space between photos', 'Ramki polaroidów': 'Polaroid frames', 'Wzór': 'Design',
    'Inicjały (np. K+J)': 'Initials (e.g. K+J)', 'Napis': 'Text', 'Napis (| = nowa linia)': 'Text (| = new line)', 'Napis na ramce': 'Text on the frame',
    'Rok pod napisem': 'Year under the text', 'Kolor napisu': 'Text color', 'Imię pupila': "Pet's name", 'Rok (EST.)': 'Year (EST.)',
    'Duży napis': 'Big word', 'Imię': 'Name', 'Data (since)': 'Date (since)', 'Tekst': 'Text', 'Ile razy napis': 'Word repeats',
    'Kolor imienia i daty': 'Name & date color', 'Tło kartki': 'Paper background', 'Czarne kreski na ciemnym ubraniu': 'Black lines on dark garments',
    'Imię i nazwisko': 'Full name', 'Data': 'Date', 'Kto': 'Who', 'Z kim': 'With', 'Napis na dole': 'Bottom line', 'Czcionka': 'Font',
    'Pismo': 'Lettering', 'Kolor imienia': 'Name color', 'Kropka po imieniu': 'Dot after the name', 'Mały napis': 'Small text',
    'Ile razy imię': 'Name repeats', 'Środkowe napisy': 'Middle lines', 'Wielki napis': 'Big text', 'Kolor': 'Color', 'Błyskawice': 'Lightning bolts',
    'Pupil': 'Pet', 'Rysunek': 'Drawing', 'Grafika': 'Artwork'
  };
  var NAME = {
    'Kolorowe': 'Color', 'Czarno-białe': 'Black & white', 'Bez odstępów': 'No gaps', 'Wąskie': 'Narrow', 'Szerokie': 'Wide', 'Białe': 'White',
    'Czarne': 'Black', 'Inicjały': 'Initials', 'Jeden polaroid': 'Single polaroid', 'Zdjęcia + napis': 'Photos + text', 'Potrójny': 'Triple',
    'Pojedynczy': 'Single', 'Usuń': 'Remove', 'Usuń mocniej': 'Remove more', 'Usuń delikatnie': 'Remove gently', 'Zostaw kartkę': 'Keep the paper',
    'Zamień na białe': 'Make them white', 'Zostaw czarne': 'Keep them black', 'Tak': 'Yes', 'Bez kropki': 'No dot', 'Kontur': 'Outline', 'Pełne': 'Solid',
    'Bez': 'None', 'Z boku': 'Side', 'Na środku': 'Center', 'Eleganckie': 'Elegant', 'Odręczne': 'Handwritten', 'Zaokrąglone': 'Rounded',
    'Oryginalny': 'Original', 'Czarny': 'Black', 'Czerwony': 'Red', 'Biały': 'White', 'Różowy': 'Pink', 'Granatowy': 'Navy', 'Brązowy': 'Brown',
    'Fioletowy': 'Purple', 'Niebieski': 'Blue', 'Zielony': 'Green', 'Pomarańczowy': 'Orange', 'Złoty': 'Gold', 'Tata': 'Dad', 'Mama': 'Mom',
    'Córka': 'Daughter', 'Syn': 'Son'
  };
  // domyslne teksty na wzorze: US imiona, daty MM.DD.YYYY (klucz: product id -> pole -> def)
  var DEF = {
    '16281445728605': { name: 'Bella' },
    '16281445335389': { name: 'Emma', since: '07.03.2025' },
    '16256881099101': { name: 'Mike Johnson', under: '11.10.2024' },
    '16628370735453': { name: 'Luna' },
    '16628370702685': { name: 'The Millers' }
  };
  var NOTE = {
    'Wystarczy zdjęcie rysunku telefonem – z góry, przy dziennym świetle. Kartkę, stół i cienie usuwamy automatycznie, na ubraniu zostaje sam rysunek.':
      'A phone photo of the drawing is enough – taken from above, in daylight. We remove the paper, table and shadows automatically; only the drawing goes on the garment.',
    'Od 1 do 5 zwierzaków. Zdjęcie nr 1 jest na środku, z przodu.': '1 to 5 pets. Photo no. 1 goes in the middle, in front.',
    'Podgląd jest poglądowy. Po zamówieniu robimy z Twojego zdjęcia prawdziwą ilustrację. Drukujemy według przesłanego zdjęcia i wybranych opcji. Wizualizację przed drukiem możesz zamówić jako płatną opcję.':
      'See it live before you order: the preview shows your layout. After you order, we turn your photo into a real illustration in this style.'
  };
  function fixField(pid, f) {
    if (!f || typeof f !== 'object') return;
    if (LABEL[f.l]) f.l = LABEL[f.l];
    if (f.k === 'top' && f.opts && f.opts[0] === 'TATA') {          // Tata i corka: napis na wzorze po angielsku
      f.opts = ['DAD', 'MOM']; f.names = { DAD: 'Dad', MOM: 'Mom' }; f.def = 'DAD'; return;
    }
    if (f.k === 'sub' && f.opts && f.opts[0] === 'i córka') {
      f.opts = ['& daughter', '& son']; f.names = { '& daughter': 'Daughter', '& son': 'Son' }; f.def = '& daughter'; return;
    }
    if (f.opts) {
      var nm = {}; f.opts.forEach(function (o) { var d = f.names && f.names[o] != null ? f.names[o] : o; nm[o] = NAME[d] || d; }); f.names = nm;
    }
    if (DEF[pid] && DEF[pid][f.k] != null && f.def != null && f.def !== '') f.def = DEF[pid][f.k];
  }
  global.KCN_US = function (P) {
    var seen = [];
    Object.keys(P).forEach(function (pid) {
      var m = P[pid];
      if (m.note && NOTE[m.note]) m.note = NOTE[m.note];
      (m.photos || []).forEach(function (ph) { if (ph && ph.n && LABEL[ph.n]) ph.n = LABEL[ph.n]; });
      (m.fields || []).forEach(function (f) {
        if (seen.indexOf(f) >= 0) { // wspolne obiekty (TONE/GAP/DZ...) - tylko domyslne per produkt
          if (DEF[pid] && DEF[pid][f.k] != null) f.def = DEF[pid][f.k];
          return;
        }
        seen.push(f); fixField(pid, f);
      });
    });
  };

  // ---------- 2) teksty w DOM kreatora ----------
  var COLOR = { 'biała': 'white', 'czarna': 'black', 'szara': 'grey', 'beżowa': 'sand', 'różowa': 'pink', 'niebieska': 'blue', 'błękitna': 'light blue',
    'brązowa': 'brown', 'granatowa': 'navy', 'zielona': 'green', 'czerwona': 'red', 'bordowa': 'maroon', 'grafitowa': 'charcoal' };
  var GARM = { 'koszulka': 't-shirt', 'bluza': 'sweatshirt', 'bluza z kapturem': 'hoodie' };
  function inch(cm) { return (Math.round(cm / 2.54 * 2) / 2).toString(); }
  var EXACT = {
    'Przybliż nadruk': 'Zoom in on the print', 'Całe ubranie': 'Whole garment', 'Twój projekt': 'Your design', 'Projekt': 'Design',
    'Na ubraniu': 'On the garment', 'Na osobie': 'On a person', 'zobacz na ubraniu i na osobie': 'see it on the garment and on a person',
    'Tak wygląda sam nadruk. Poniżej zobaczysz go na ubraniu i na osobie.': 'This is the print on its own. Below you can see it on the garment.',
    'Zdjęcie produktu': 'Product photo', 'Przykład z naszej pracowni. Twój projekt zobaczysz w podglądzie powyżej.': 'An example from our studio. Your design is shown in the preview above.',
    'Jedno z Twoich zdjęć ma małą rozdzielczość – na nadruku może wyjść nieostro. Najlepiej wgraj oryginał z telefonu.':
      'One of your photos has a low resolution – the print may look blurry. Best to upload the original from your phone.',
    'Zdjęcie': 'Photo', 'Kadr zdjęć – kliknij „Kadr”, żeby wybrać fragment': 'Photo crop – click "Crop" to choose the area', 'Kadr': 'Crop',
    'Kliknij, aby dodać zdjęcie': 'Click to add a photo', 'Powiększenie zdjęcia': 'Photo zoom', 'Przybliż': 'Zoom', 'Wyśrodkuj zdjęcie': 'Center the photo',
    'Gotowe': 'Done', 'JPG, PNG lub HEIC · prosto z telefonu': 'JPG, PNG or HEIC · straight from your phone','Podgląd nadruku': 'Print preview', 'Wycinamy tło ze zdjęcia…': 'Removing the photo background…',
    'Teraz widzisz przykładowe zdjęcia. Wgraj swoje w opcjach produktu – podgląd zmieni się od razu.': 'You are seeing sample photos. Upload yours in the product options – the preview updates right away.',
    'Mniejszy wzór': 'Smaller design', 'Większy wzór': 'Larger design', 'Wielkość wzoru': 'Design size', 'Wielkość i położenie wzoru': 'Design size and position',
    'Położenie': 'Position', 'Wyżej': 'Up', 'Niżej': 'Down', 'W lewo': 'Left', 'W prawo': 'Right', 'Wyśrodkuj': 'Center',
    'Możesz też przeciągnąć wzór palcem albo myszką na podglądzie.': 'You can also drag the design with your finger or mouse on the preview.',
    'Chwilka – jeszcze wycinamy tło ze zdjęcia.': 'One moment – we are still removing the photo background.',
    'Podgląd nadruku na żywo': 'Live print preview', 'Przewiń do pełnego podglądu': 'Scroll to the full preview', 'PODGLĄD': 'PREVIEW',
    'Koszulka – przód': 'T-shirt – front', 'Koszulka – plecy': 'T-shirt – back', 'Bluza – przód': 'Sweatshirt – front', 'Bluza – plecy': 'Sweatshirt – back',
    'Bluza z kapturem – przód': 'Hoodie – front', 'Bluza z kapturem – plecy': 'Hoodie – back'
  };
  var RULES = [
    [/^Zdjęcie (\d+)$/, 'Photo $1'],
    [/^Zdjęcie (\d+): przesuń jasną ramkę – to, co w niej, będzie na nadruku\.$/, 'Photo $1: move the light frame – whatever is inside it gets printed.'],
    [/^Dodaj jeszcze zdjęcie (\d+) – ten wzór ma 2 zdjęcia\.$/, 'Add photo $1 too – this design uses 2 photos.'],
    [/Podgląd na bluzie z kapturem – bluza rozpinana ma zamek na środku\. ?/, 'Preview on a hoodie – the zip hoodie has a zipper in the middle. '],
    [/Nadruk ok\. (\d+) × (\d+) cm\. Przeciągnij wzór, żeby go przesunąć\./, function (m, w, h) { return 'Print approx. ' + inch(+w) + ' × ' + inch(+h) + ' in. Drag the design to move it.'; }],
    [/^Nadruk jest na (plecach|przodzie) – wybierz drugie zdjęcie poniżej\.$/, function (m, s) { return 'The print is on the ' + (s === 'plecach' ? 'back' : 'front') + ' – pick the other photo below.'; }],
    [/^Zdjęcie poglądowe: (.+?) w kolorze (.+)\.$/, function (m, g, c) { return 'Sample photo: ' + (GARM[g] || g) + ' in ' + (COLOR[c] || c) + '.'; }],
    [/^(Koszulka|Bluza z kapturem|Bluza) · (.+?) · (przód|plecy|lewa pierś|prawa pierś)$/, function (m, g, c, s) {
      return (GARM[g.toLowerCase()] || g).replace(/^./, function (x) { return x.toUpperCase(); }) + ' · ' + (COLOR[c] || c) + ' · ' +
        ({ 'przód': 'front', 'plecy': 'back', 'lewa pierś': 'left chest', 'prawa pierś': 'right chest' }[s]); }]
  ];
  function tr(s) {
    var t = s.trim(); if (!t) return s;
    var r = EXACT[t];
    if (r == null) {
      for (var i = 0; i < RULES.length; i++) { if (RULES[i][0].test(t)) { r = t.replace(RULES[i][0], RULES[i][1]); break; } }
    }
    if (r == null || r === t) return s;
    return s.replace(t, r);
  }
  var SCOPE = '[data-kc-options],[class*="kcn"],[class*="kca"],[class*="kcp-"]';
  function inScope(n) { var e = n.nodeType === 1 ? n : n.parentElement; return e && e.closest && e.closest(SCOPE); }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { if (inScope(root)) { var v = tr(root.nodeValue); if (v !== root.nodeValue) root.nodeValue = v; } return; }
    if (root.nodeType !== 1 || /^(SCRIPT|STYLE|TEXTAREA)$/.test(root.tagName)) return;
    if (inScope(root)) {
      ['aria-label', 'placeholder', 'title', 'alt'].forEach(function (a) {
        var v = root.getAttribute(a); if (v) { var n = tr(v); if (n !== v) root.setAttribute(a, n); }
      });
    }
    for (var c = root.firstChild; c; c = c.nextSibling) walk(c);
  }
  function observe() {
    walk(doc.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'characterData') walk(m.target);
        else if (m.type === 'attributes') walk(m.target);
        else m.addedNodes.forEach(walk);
      });
    }).observe(doc.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'placeholder', 'title'] });
  }

  // ---------- 3) podpisy na canvasie ----------
  var proto = global.CanvasRenderingContext2D && CanvasRenderingContext2D.prototype;
  if (proto && !proto.__kcnEn) {
    var fill = proto.fillText;
    proto.fillText = function (txt) {
      if (typeof txt === 'string') {
        if (txt === 'Zdjęcie') txt = 'Photo';
        else if (/^Zdjęcie \d+$/.test(txt)) txt = txt.replace('Zdjęcie', 'Photo');
        else if (txt === 'PUPIL') txt = 'BUDDY';
        if (txt !== arguments[0]) { var a = Array.prototype.slice.call(arguments); a[0] = txt; return fill.apply(this, a); }
      }
      return fill.apply(this, arguments);
    };
    proto.__kcnEn = true;
  }

  // ---------- 4) koszyk: etykiety wlasciwosci EN, cm -> cale (_kca bez zmian) ----------
  var PLACE_EN = { 'Przód': 'Front', 'Plecy': 'Back', 'Lewa pierś': 'Left chest', 'Prawa pierś': 'Right chest' };
  var PROP = { 'Położenie wzoru': 'Design placement', 'Podgląd projektu': 'Design preview', 'Projekt (przezroczyste tło)': 'Design (transparent background)' };
  function fixForm(form) {
    Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (i) {
      var n = i.name.slice(11, -1);
      if (n.charAt(0) === '_') return;
      var nn = PROP[n] || n.replace(/ \(styl\)$/, ' (style)');
      if (n === 'Położenie wzoru' && i.type === 'hidden') {
        var v = i.value;
        Object.keys(PLACE_EN).forEach(function (k) { if (v.indexOf(k) === 0) v = PLACE_EN[k] + v.slice(k.length); });
        v = v.replace(/, ok\. (\d+) × (\d+) cm/, function (m, w, h) { return ', approx. ' + inch(+w) + ' × ' + inch(+h) + ' in'; })
             .replace(', wielkość ', ', size ').replace(', przesunięty', ', moved');
        i.value = v;
      }
      if (nn !== n) i.name = 'properties[' + nn + ']';
    });
  }
  function wrapSubmit() {
    var K = global.KCO;
    if (!K || !K.hooks || typeof K.hooks.beforeSubmit !== 'function') return false;
    if (K.hooks.beforeSubmit.__kcnEn) return true;
    var orig = K.hooks.beforeSubmit;
    var w = function (form) {
      var r = orig.apply(this, arguments);
      fixForm(form);
      return r && typeof r.then === 'function' ? r.then(function (x) { fixForm(form); return x; }) : r;
    };
    w.__kcnEn = true; K.hooks.beforeSubmit = w; return true;
  }
  // kreator ustawia hook przy starcie (po kco:ready) i moze nadpisac wczesniejszy -> pilnujemy przez 30 s
  var tries = 0, iv = setInterval(function () { wrapSubmit(); if (++tries > 120) clearInterval(iv); }, 250);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', observe); else observe();
})(window);
